import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NovaIcon } from '@rds-nova/angular-icon';

import { SUPPORT_PHONE_NUMBER } from 'src/app/core/constants/support';

@Component({
  selector: 'app-session-unavailable',
  imports: [TranslatePipe, NovaIcon],
  templateUrl: './session-unavailable.component.html',
  styleUrl: './session-unavailable.component.scss',
})
export class SessionUnavailable {
  protected readonly phoneNumber = SUPPORT_PHONE_NUMBER;
}
